<template>
    <div>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span>{{groupInfo.groupName}}</span>
            </div>
            <div style="float: right;margin-top: -66px;">
                <el-button @click="currentChangeHandle(1)">刷新参数列表</el-button>
                <el-button @click="addOrUpdateHandle(groupId)">修改分组</el-button>
                <el-button @click="deleteHandle(groupId)">删除分组</el-button>
                <el-button @click="deleteSelectItem()">删除子项</el-button>
                <el-button @click="newItemHandle(groupId)">新增子项</el-button>
                <el-button @click="chooseItemHandle(groupId)">选择数据项目</el-button>
                <!--                    <el-button type="primary" @click="saveDataList()">保存</el-button>-->
            </div>
            <el-table
                    :data="dataList"
                    row-key="id"
                    ref="multipleTable"
                    border
                    stripe
                    v-loading="dataListLoading"
                    @selection-change="selectionChangeHandle"
                    style="width: 100%">
                <el-table-column
                        fixed
                        type="index"
                        align="center"
                        label="序号"
                        width="50"
                        :index="getRowsIndex">
                </el-table-column>
                <el-table-column type="selection"  align="center" fixed></el-table-column>
                <el-table-column
                        fixed
                        align="center"
                        width="100"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" @click="addOrUpdateItemHandle(scope.row.id,scope.row.formId, scope.row.groupId)">编辑</el-button>
                        <el-button type="text" @click="deleteHandleField(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
                <el-table-column
                        fixed
                        prop="columnName"
                        header-align="left"
                        align="left"
                        width="120"
                        label="字段名称">
                </el-table-column>
                <el-table-column
                        prop="columnType"
                        header-align="left"
                        align="left"
                        width="120"
                        label="字段类型">
                    <template slot-scope="scope">
                        <span>{{formatterDataDictionary(columnTypeList,scope.row.columnType)}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="displayName"
                        header-align="left"
                        align="left"
                        width="150"
                        label="显示名">
                </el-table-column>
                <el-table-column
                        prop="showInList"
                        align="center"
                        width="80"
                        label="是否显示"
                >
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.showInList === true" size="small">是</el-tag>
                        <el-tag v-if="scope.row.showInList === false" size="small" type="danger">否</el-tag>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="textType"
                        align="center"
                        width="80"
                        label="是否显示显示名"
                >
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.textType == 1" size="small">是</el-tag>
                        <el-tag v-else size="small" type="danger">否</el-tag>
                    </template>
                </el-table-column>
              <el-table-column
                  prop="isQueryParam"
                  align="center"
                  width="80"
                  label="是否为查询参数"
              >
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.isQueryParam" size="small">是</el-tag>
                  <el-tag v-else size="small" type="danger">否</el-tag>
                </template>
              </el-table-column>
<!--                <el-table-column-->
<!--                        prop="showLength"-->
<!--                        align="center"-->
<!--                        width="80"-->
<!--                        label="控制长度"-->
<!--                >-->
<!--                </el-table-column>-->
                <el-table-column
                        prop="datasourceType"
                        header-align="left"
                        width="100"
                        align="left"
                        label="数据源类型">
                    <template slot-scope="scope">
                        <span>{{formatterDataDictionary1(datasourceTypeList,scope.row.datasourceType)}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="datasource"
                        header-align="left"
                        align="left"
                        label="数据源"
                        show-overflow-tooltip>
                </el-table-column>

                <el-table-column
                        prop="columnCount"
                        align="center"
                        width="115"
                        label="列数">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.columnCount == 3"  size="small">三列</el-tag>
                        <el-tag v-else-if="scope.row.columnCount == 2" type="success" size="small">双列</el-tag>
                        <el-tag v-else-if="scope.row.columnCount == 1" size="small" type="danger">单列(整行)</el-tag>
                    </template>
                </el-table-column>
<!--                <el-table-column-->
<!--                        prop="columnWidth"-->
<!--                        align="center"-->
<!--                        label="列宽">-->
<!--                </el-table-column>-->
<!--              <el-table-column-->
<!--                  prop="singFlag"-->
<!--                  align="center"-->
<!--                  label="是否单行"-->
<!--              >-->
<!--                <template slot-scope="scope">-->
<!--                    <el-tag v-if="scope.row.singFlag === true" size="small">是</el-tag>-->
<!--                    <el-tag v-else size="small" type="danger">否</el-tag>-->
<!--                </template>-->
<!--              </el-table-column>-->
<!--              <el-table-column-->
<!--                  prop="textType"-->
<!--                  header-align="left"-->
<!--                  align="center"-->
<!--                  label="显示选项"-->
<!--              >-->
<!--                <template slot-scope="scope">-->
<!--                    <el-tag v-if="scope.row.textType == 0"  size="small">列表</el-tag>-->
<!--                    <el-tag v-else-if="scope.row.textType == 2" type="success" size="small">编辑</el-tag>-->
<!--                    <el-tag v-else size="small" type="danger">显示名及内容</el-tag>-->
<!--                </template>-->
<!--              </el-table-column>-->
                <el-table-column
                        prop="sort"
                        width="80"
                        align="center"
                        label="排序">
                </el-table-column>

            </el-table>
        </el-card>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
        <!-- 弹窗, 新增 / 修改 -->
        <add-or-update-item v-if="addOrUpdateItemVisible" ref="addOrUpdateItem" @refreshDataList="getDataList"></add-or-update-item>
        <!-- 弹窗, 新增 / 修改 -->
        <choose-item v-if="chooseItemVisible" ref="chooseItem" @refreshDataList="getDataList"></choose-item>

    </div>
</template>

<script>
    import AddOrUpdate from "./detail_config_dataset_group_add"
    import AddOrUpdateItem from "./detail_config_dataset_group_list_item_add"
    import ChooseItem from "./detail_config_dataset_group_choose"
    import axios from "axios";

    export default {
        props: {
            formId: {
                type: String,
                required: true,
            },
            groupId: {
                type: String,
                required: true,
            },
            groupInfo: {
                required: true
            }
        },
        components: {
            AddOrUpdate, ChooseItem,AddOrUpdateItem
        },
        data() {
            return {
                datasourceTypeList: [],
                columnTypeList:[],
                dictCateList: [],
                pageIndex: 1,
                pageSize: 100,
                dataList: [],
                groupList: [],
                trueOrFalseOptions: [{'text': '否', 'value': false}, {'text': '是', 'value': true}],
                textOptions: [{'text': '显示label', 'value': 1}, {'text': '不显示label', 'value': 2}],
                dataListLoading: false,
                dataListSelections: [],
                addOrUpdateVisible: false,
                addOrUpdateItemVisible: false,
                chooseItemVisible: false,
                itemListBatchsettingVisible: false,
                importFieldListVisible: false,
            };
        },
        created() {
            this.getDic('form_input_type');
        },
        mounted() {
            this.initSelectData()
            this.getDataList();

        },
        methods: {
            getDic(type) { // 获取字典
                this.$httpReq.get('/sys/dictData/getList?type=' + type).then(res => {
                    if (res.data.code === '1') {
                        switch (type) {
                            case 'form_input_type':this.columnTypeList = res.data.data;break;
                        }
                    }
                })
            },
            formatterDataDictionary1(list,value) {
                const item = list.filter(sl => sl.id == value)[0];
                return item != null ? item.text : "";
            },
            addOrUpdateItemHandle (id,formId, groupId) {
                this.addOrUpdateItemVisible = true
                this.$nextTick(() => {
                    this.$refs.addOrUpdateItem.init(id,formId,groupId,this.customList)
                })
            },

            // 新增 / 修改
            addOrUpdateHandle() {
                this.addOrUpdateVisible = true
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init(this.formId, this.groupId)
                })
            },
            chooseItemHandle() {
                this.chooseItemVisible = true
                this.$nextTick(() => {
                    this.$refs.chooseItem.init(this.groupInfo)
                })
            },
            getHttpReq(url, method = "post", extOps) {
                let ops = {
                    url: url,
                    method: method,
                    baseURL:  process.env.VUE_APP_proxybaseurl + '',
                };
                ops = Object.assign(ops, extOps);
                return this.$httpReq(ops);
            },
            initSelectData() {
                let _self = this;
                axios
                    .all([
                        this.getHttpReq("/customform/getEnumList/0?required=true", "get"),
               //         this.getHttpReq("/sys/dict/getDictCategoryList2", "get"),
                    ])
                    .then(
                        axios.spread(function (datasourceTypes, dictCataegory) {
                            let tmp = datasourceTypes.data
                            let result = []
                            for (var i = 0; i < tmp.length; i++) {
                                let item = tmp[i];
                                if (item.id == 4 || item.id == 5 || item.id == 6) {
                                    continue
                                }
                                result.push(item)
                            }
                            _self.datasourceTypeList = _self.transformToInt(result);
                            _self.dictCateList = (dictCataegory && dictCataegory.data) || [];
                        })
                    );
            },
            transformToInt(data) {
                let tmp = []
                for (let index = 0; index < data.length; index++) {
                    const element = data[index];
                    element.id = parseInt(element.id)
                    if (isNaN(element.id)) {
                        element.id = 0
                    }
                    tmp.push(element)
                }
                return tmp
            },
            getRowsIndex(index) {
                return (this.pageIndex - 1) * this.pageSize + index + 1;
            },
            // 每页数
            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.getDataList();
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val;
                this.getDataList();
            },
            // 多选
            selectionChangeHandle(val) {
                this.dataListSelections = val;
            },
            // 获取数据列表
            getDataList() {
                this.dataListLoading = true;
                this.$httpReq({
                    url: "/customform/fromdatasetfield/list",
                    method: "post",
                    baseURL:  process.env.VUE_APP_proxybaseurl + '',
                    data: {
                        filter: {
                            formId: this.formId,
                            groupId: this.groupId
                        },
                        page: this.pageIndex,
                        rows: this.pageSize,
                    },
                }).then(({data}) => {
                    if (data) {
                        this.dataList = data.rows;
                        this.$refs.multipleTable.doLayout()
                        this.pageIndex = data.pageIndex;
                    } else {
                        this.dataList = [];
                        this.pageIndex = 1;
                    }
                    this.dataListLoading = false;
                });
            },
            saveDataList() {
                this.$httpReq({
                    url: "/customform/fromdatasetfield/batchUpdate",
                    method: "post",
                    baseURL:  process.env.VUE_APP_proxybaseurl + '',
                    data: this.dataList,
                }).then(({data}) => {
                    if (data && data.code === '1') {
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 1500,
                            onClose: () => {
                                this.getDataList()
                            }
                        })
                    } else {
                        this.$message.error(data.msg)
                    }
                });
            },
            newItemHandle(groupId){
                this.addOrUpdateItemVisible = true
                this.$nextTick(() => {
                    this.$refs.addOrUpdateItem.init("",this.formId,groupId,this.customList)
                })
            },
            // 批量删除
            deleteSelectItem() {
                let ids = new Array();
                this.dataListSelections.forEach(key => {
                    ids.push(key.id)
                })

                if (ids != "" || ids.length > 0) {
                    this.$httpReq({
                        url: "/customform/fromdatasetfield/delete",
                        method: "post",
                        baseURL:  process.env.VUE_APP_proxybaseurl + '',
                        idList: ids
                    }).then(res => {
                        if (res.data.code == '1') {
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                            })
                            this.getDataList();
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.data.msg
                            })
                        }
                    })
                } else {
                    this.$message({
                        type: 'error',
                        message: "未选择删除项。"
                    })
                }

            },
            // 删除
            deleteHandle() {
                let id = this.groupId
                this.$confirm(`确定要删除该数据?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "danger",
                })
                    .then(() => {
                        this.$httpReq({
                            url: "/customform/fromdatasetgroup/delete",
                            method: "post",
                            baseURL: process.env.VUE_APP_proxybaseurl + '',
                            data: {
                              id:id
                            },
                        }).then(({data}) => {
                            if (data && data.code === "1") {
                                this.$emit("refreshDataList");
                                this.$message({
                                    message: "操作成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.getDataList();
                                    },
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    })
                    .catch(() => {
                    });
            },
            // 删除
            deleteHandleField(id) {
                this.$confirm(`确定要删除该数据?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "danger",
                })
                    .then(() => {
                        this.$httpReq({
                            url: "/customform/fromdatasetfield/delete",
                            method: "post",
                            baseURL:  process.env.VUE_APP_proxybaseurl + '',
                            data: {
                                id:id
                            },
                        }).then(({ data }) => {
                            if (data && data.code === "1") {
                                this.$message({
                                    message: "操作成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.getDataList();
                                    },
                                });
                                this.$parent.getDataList();
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    })
                    .catch(() => {});
            },
        },
    };
</script>
